// Placeholder value resolution helpers for `${...}` loop syntax.
// Example: `${bp.size}` resolves directly while `${ind + 1}` uses expression evaluation.
import type { LuisArrayVariables, LuisObjectVariables } from '../../types'
import { evaluateLoopPlaceholderExpression } from './placeholder-expression'
import type { LoopScope, ParsedLoopPlaceholder } from './types'

// Resolve one parsed placeholder against the current loop scope.
export function resolveLoopPlaceholderValue(
  placeholder: ParsedLoopPlaceholder,
  scope: LoopScope,
  arrays: LuisArrayVariables,
  variables: Record<string, string>,
  objectVariables: LuisObjectVariables,
): string | null {
  // Resolve direct key placeholders from the loop scope map.
  if (placeholder.mode === 'key') {
    // Return the direct scope hit or null when absent.
    return placeholder.key in scope ? scope[placeholder.key] : null
  }

  // Return the evaluated `${...}` expression result.
  return evaluateLoopPlaceholderExpression(placeholder.key, scope, variables, objectVariables, arrays)
}
